import React, { Component } from 'react';
import { Button, Input, Modal, Tabs, Text } from '@Sage/hoi-poi-ui';
import ZendeskUtils from '../../utils/ZendeskUtils';
import { getLiteral } from 'utils/getLiteral';
import DisableIntegration from '../CustomIntegrationsComponents/disableIntegration';
import { ProviderInactive } from '..';
import Context from 'managers/Context';
import Loading from 'components/Loading';
import './style.scss';

const ZENDESK_TABS = {
    status: 'status',
    matching: 'matching',
};

export default class ZendeskComponent extends Component {
    state = {};

    componentDidMount() {
        let { provider } = this.props;

        if (provider && provider.data) {
            this.setState({
                configuration: provider.data.Configuration,
                providerId: provider.data.ProviderId,
                loadingZendeskTabs: true,
                errorZendeskTabs: false,
                zendeskOuthProcess: false,
                validAuth: false,
                isActive: provider.data.IsActive,
                loading: true,
                showDisableDialog: false,
                showLoadingDisableDialog: false,
                loadingDialog: false,
                toggled: true,
                activeTab: ZENDESK_TABS.status,
            });
            if (provider.data.IsActive) {
                this.getZendeskData();
            } else {
                this.setState({ loading: false });
            }
        }
    }

    getZendeskData = (forceGoToDomain) => {
        let { provider, webTemplates } = this.props;
        Context.settingsManager.validateOauth(
            provider.data.ProviderId,
            () => {
                if (!provider.data.IsActive) {
                    Context.settingsManager.setActivation(
                        provider.data.ProviderId,
                        () => {
                            this.setState({
                                isActive: true,
                                validAuth: true,
                                loading: false,
                                zendeskOuthProcess: false,
                            });
                            this.getTab1Data(provider.data.ProviderId);
                            if (!this.checkZendeskWidget(webTemplates, 'idwidget', '8')) {
                                Context.settingsManager.refreshWebTemplates(
                                    () => {},
                                    (error) => {
                                        console.log('error refresh web4');
                                    },
                                );
                            }
                        },
                        (error) => {
                            console.log('error isactive');
                        },
                    );
                } else {
                    this.setState({
                        isActive: true,
                        validAuth: true,
                        loading: false,
                        zendeskOuthProcess: false,
                    });
                    this.getTab1Data(provider.data.ProviderId);
                }
            },
            () => {
                if (forceGoToDomain === true) {
                    this.setState({ loading: false, zendeskOuthProcess: false, isActive: false });
                } else {
                    this.setState({ loading: false });
                }
            },
            (error) => {
                this.setState({ loading: false, error: true });
            },
        );
    };

    checkZendeskWidget = (webTemplates, key, valuetosearch) => {
        for (let i = 0; i < webTemplates.length; i++) {
            if (webTemplates[i][key] === valuetosearch) {
                return true;
            }
        }
        return false;
    };

    getTab1Data = (providerId) => {
        Context.settingsManager.getCronStatus(
            providerId,
            (cronstatus) => {
                this.setState({ cronstatus: cronstatus });
                this.getTab2Data();
            },
            (cronstatus) => {
                this.setState({ cronstatus: cronstatus, loadingZendeskTabs: false });
            },
            (error) => {
                this.setState({ loadingZendeskTabs: false, errorZendeskTabs: true });
            },
        );
    };

    getTab2Data = () => {
        Context.settingsManager.mismatchedTickets(
            (data) => {
                this.setState({
                    errorZendeskTabs: false,
                    matchingData: data,
                    loadingZendeskTabs: false,
                });
            },
            () => {
                this.setState({ loadingZendeskTabs: false, errorZendeskTabs: true });
            },
            (error) => {
                this.setState({ loadingZendeskTabs: false, errorZendeskTabs: true });
            },
        );
    };

    renderZendeskDomainContent = () => {
        return (
            <div className="zendesk-detail-provider">
                <Text as="div" className="zendesk-title" medium type="subtitle1">
                    {getLiteral('title_integration_zendesk')}
                </Text>
                <div className="provider-detail">
                    <div className="content">
                        <Text as="div" className="description" type="body">
                            {getLiteral('label_authorize_description_zendesk')}
                        </Text>
                    </div>
                </div>
                <div className="zendesk-input-domain">
                    <Input
                        id="input-domain"
                        className="zendesk-domain-input"
                        value={this.state.zendeskdomain || ''}
                        onChange={this.handleDomainChange}
                        isFullWidth
                        placeholder={getLiteral('placeholder_text_field')}
                        placeholderReadOnly={getLiteral('placeholder_text_field')}
                        preComponent={<span className="zendesk-domain-affix">https://</span>}
                        postComponent={<span className="zendesk-domain-affix">.zendesk.com</span>}
                    />
                </div>
                <div className="zendesk-authorize-btn">
                    <Button onClick={this.onClickAuthorize} type="primary">
                        {getLiteral('action_authorize_zendesk')}
                    </Button>
                </div>
            </div>
        );
    };

    handleDomainChange = (value) => {
        this.setState({ zendeskdomain: (value || '').toLowerCase() });
    };

    onClickAuthorize = () => {
        let { iduser, implementation } = this.props;
        let { zendeskdomain } = this.state;

        if (zendeskdomain && zendeskdomain.length > 0) {
            this.setState({ zendeskOuthProcess: true });
            let child = window.open(
                ZendeskUtils.getZendeskUrl(zendeskdomain, iduser, implementation),
                '_blank',
                'width:550,height:700,modal=yes,alwaysRaised=yes',
            );

            let timer = setInterval(() => {
                if (child.closed) {
                    this.getZendeskData(true);
                    clearInterval(timer);
                }
            }, 500);
        }
    };

    onClickActivate = () => {
        this.setState({ isActive: true });
    };

    onClickDisable = (isInputChecked) => {
        if (!isInputChecked) {
            this.setState({ showDisableDialog: true, toggled: true });
        }
    };

    handleDisableClose = () => {
        const { loadingDialog, showLoadingDisableDialog } = this.state;
        if (!showLoadingDisableDialog && !loadingDialog) {
            this.setState({ showDisableDialog: false, toggled: true });
        }
    };

    handleDisable = () => {
        this.setState({ showLoadingDisableDialog: true, loadingDialog: true });
        let { providerId } = this.state;
        Context.settingsManager.disableIntegration(
            providerId,
            () => {
                this.setState({
                    showDisableDialog: false,
                    showLoadingDisableDialog: false,
                    loadingDialog: false,
                    validAuth: false,
                    isActive: false,
                });
            },
            (error) => {
                console.log('error isactive');
                this.setState({
                    showDisableDialog: false,
                    showLoadingDisableDialog: false,
                    loadingDialog: false,
                    toggled: true,
                });
            },
        );
    };

    onChangeTab = (activeTab) => {
        this.setState({ activeTab });
    };

    renderZendeskTabsContent = () => {
        let { provider } = this.props;
        let { activeTab, loadingZendeskTabs, errorZendeskTabs, toggled } = this.state;

        let renderContent = loadingZendeskTabs ? (
            this.renderLoading()
        ) : errorZendeskTabs ? (
            this.renderError()
        ) : (
            <div id="active-integration-container">
                <DisableIntegration
                    onDisable={this.onClickDisable}
                    provider={provider}
                    toggled={toggled}
                />
                <Tabs
                    activeKey={activeTab}
                    className="integrations-tabs"
                    onChange={this.onChangeTab}
                    tabs={[
                        {
                            key: ZENDESK_TABS.status,
                            title: getLiteral('label_status_zendesk'),
                            content: this.renderStatusTab(),
                        },
                        {
                            key: ZENDESK_TABS.matching,
                            title: getLiteral('label_matching_zendesk'),
                            content: this.renderMatchingTab(),
                        },
                    ]}
                />
            </div>
        );
        return renderContent;
    };

    renderStatusTab = () => {
        let { cronstatus } = this.state;

        if (cronstatus === 'enabled') {
            return this.renderSyncStatusBlock(
                'oval-green',
                'label_enabled_sync_zendesk',
                'label_enabled_sync_description_zendesk',
            );
        }

        if (cronstatus === 'inprogress') {
            return this.renderSyncStatusBlock(
                'oval-yellow',
                'label_initial_sync_zendesk',
                'label_sync_description_zendesk',
            );
        }

        return this.renderSyncStatusBlock(
            'oval-red',
            'label_failed_sync_zendesk',
            'label_failed_sync_description_zendesk',
        );
    };

    renderSyncStatusBlock = (ovalClass, titleLiteral, descLiteral) => (
        <div className="zendesk-inside-tab-content">
            <div className="zendesk-status-container">
                <span className={`oval ${ovalClass}`} />
                <Text as="div" className="zendesk-status-text" medium type="subtitle1">
                    {getLiteral(titleLiteral)}
                </Text>
            </div>
            <Text as="div" className="zendesk-status-desc" type="body">
                {getLiteral(descLiteral)}
            </Text>
        </div>
    );

    renderMatchingTab = () => {
        let { matchingData, cronstatus } = this.state;

        if (cronstatus !== 'enabled') {
            return (
                <div className="zendesk-inside-tab-content">
                    <Text as="div" className="zendesk-no-matching-content" type="body">
                        {getLiteral('label_no_matching_content_zendesk')}
                    </Text>
                </div>
            );
        }

        return (
            <div className="zendesk-inside-tab-content">
                <div className="zendesk-matching-summary">
                    <Text as="span" className="zendesk-matching-num" type="h2">
                        {matchingData.matching || '0'}%
                    </Text>
                    <Text as="span" className="zendesk-matching-num-desc" medium type="subtitle1">
                        {getLiteral('label_match_percent_description_zendesk')}
                    </Text>
                </div>
                <Text as="div" className="zendesk-matching-desc" type="body">
                    {getLiteral('label_match_description_zendesk')}
                </Text>
                {matchingData.tickets.length > 0
                    ? this.renderTicketsTable(matchingData.tickets)
                    : null}
            </div>
        );
    };

    renderTicketsTable = (tickets) => {
        return (
            <table className="zendesk-ticket-table">
                <thead>
                    <tr>
                        <th>
                            <Text medium type="body">
                                {getLiteral('label_subject_zendesk')}
                            </Text>
                        </th>
                        <th className="w-125">
                            <Text medium type="body">
                                {getLiteral('label_created_zendesk')}
                            </Text>
                        </th>
                        <th>
                            <Text medium type="body">
                                {getLiteral('label_requester_zendesk')}
                            </Text>
                        </th>
                        <th>
                            <Text medium type="body">
                                {getLiteral('label_requester_email_zendesk')}
                            </Text>
                        </th>
                    </tr>
                </thead>
                <tbody>{this.renderTicketRows(tickets)}</tbody>
            </table>
        );
    };

    renderTicketRows = (tickets) => {
        let ticketRows = tickets.map((ticket, index) => {
            let createdDateFormatted = '';
            if (ticket.createddate) {
                createdDateFormatted = Context.utilsFormats.formatStringByInputFormat(
                    ticket.createddate,
                    'YYYY-MM-DDTHH:mm:ss',
                    true,
                );
            }
            return (
                <tr key={index}>
                    <td>
                        <Text type="body">{ticket.description || ''}</Text>
                    </td>
                    <td>
                        <Text type="body">{createdDateFormatted}</Text>
                    </td>
                    <td>
                        <Text type="body">{ticket.requestername || ''}</Text>
                    </td>
                    <td>
                        <Text type="body">{ticket.requesteremail || ''}</Text>
                    </td>
                </tr>
            );
        });

        return ticketRows;
    };

    renderError = () => {
        return (
            <div className="integrations">
                <div className="description-integrations">
                    <Text type="body">{getLiteral('error_unexpected')}</Text>
                </div>
            </div>
        );
    };

    renderLoading = () => {
        return (
            <div>
                <Loading />
            </div>
        );
    };

    renderZendeskActivation = (provider) => {
        return (
            <div className="zendesk-activation">
                <ProviderInactive provider={provider} />
                <div className="zendesk-activate-btn">
                    <Button onClick={this.onClickActivate} type="primary">
                        {getLiteral('action_activate_zendesk')}
                    </Button>
                </div>
            </div>
        );
    };

    renderOauthInProcess = () => {
        return (
            <div className="zendesk-waiting-content">
                <Text as="div" className="zendesk-waiting-text" type="body">
                    {getLiteral('label_waiting_oauth_zendesk')}
                </Text>
                <Button onClick={this.getZendeskData} type="primary">
                    {getLiteral('action_waiting_oauth_zendesk')}
                </Button>
            </div>
        );
    };

    render() {
        let { provider } = this.props;
        let {
            error,
            loading,
            zendeskOuthProcess,
            isActive,
            validAuth,
            showDisableDialog,
            loadingDialog,
        } = this.state;
        let renderContent = loading
            ? this.renderLoading()
            : error
              ? this.renderError()
              : !isActive
                ? this.renderZendeskActivation(provider)
                : zendeskOuthProcess
                  ? this.renderOauthInProcess()
                  : !validAuth
                    ? this.renderZendeskDomainContent()
                    : this.renderZendeskTabsContent();
        return (
            <div className="integrations-management zendesk-management-integration">
                {renderContent}
                <Modal
                    overrides={{
                        confirmButton: {
                            type: 'primary-error',
                        },
                    }}
                    useCornerClose={false}
                    isOpen={showDisableDialog}
                    onRequestClose={this.handleDisableClose}
                    onCancel={this.handleDisableClose}
                    onConfirm={this.handleDisable}
                    title={getLiteral('helptext_confirm')}
                    confirmText={getLiteral('action_accept')}
                    cancelText={getLiteral('action_cancel')}
                    size="small"
                    isConfirmLoading={loadingDialog}
                >
                    <Text>{getLiteral('label_disable_zendesk')}</Text>
                </Modal>
            </div>
        );
    }

    existTokenConfiguration = (configuration) => {
        if (configuration && configuration !== null) {
            let token = configuration.find((conf) => conf.Label === 'Token');
            if (token && token.KeyValue) {
                return token.KeyValue.Token.length > 0;
            }
        }
        return false;
    };
}
